module.exports = __webpack_public_path__ + "img/room9.9edc8900.gif";